import {
    Button,
    Card,
    CardContent,
    CardFooter,
    CardHeader,
    Separator,
} from '@repo/shadcn';
import { FormProvider } from 'react-hook-form';
import { Link } from 'react-router-dom';

import { BackBtnIcon, InfoIcon } from '@/assets/svg.icons/icons';
import HeadingWrapper from '@/components/ui/heading/heading-wrapper';
import PageHeading from '@/components/ui/heading/page-headeing';
import BtnLoader from '@/components/ui/loader/btn-loader';

import { createProduct } from '../utils/product-inputs';
import CreateProductInformation from './create-product-information';
import CreateProductVariation from './create-product-variation';
import { useCreateProduct } from './create-product.hook';

export const CreateProduct = () => {
    const {
        createProductform,
        handleProductSubmit,
        isLoading,
        handleSubmit,
        isValid,
        fields,
        append,
        remove,
        onClickFormActionBtn,
        control,
        fieldOptionsForPricing,
    } = useCreateProduct();

    return (
        <>
            <HeadingWrapper>
                <div className="flex items-center justify-between">
                    <PageHeading
                        title="Create New Product"
                        subTitle="Fill out the form to create a new product."
                    />
                    <Link to="/products">
                        <Button variant="default">
                            <BackBtnIcon />
                            Back to Products
                        </Button>
                    </Link>
                </div>
            </HeadingWrapper>

            <div className="srounded-md mt-5 bg-white shadow-sm">
                <FormProvider {...createProductform}>
                    <form onSubmit={handleSubmit(handleProductSubmit)}>
                        <Card className="border-none py-5">
                            <CardContent>
                                <CardHeader>
                                    <div className=" flex items-center text-[18px] font-semibold text-gray-600">
                                        <InfoIcon />
                                        {createProduct.productInformation.title}
                                    </div>
                                </CardHeader>
                                <Separator />
                                <CreateProductInformation
                                    onClickFormActionBtn={onClickFormActionBtn}
                                />
                                <Separator className="mt-10" />
                                <CreateProductVariation
                                    fields={fields}
                                    append={append}
                                    remove={remove}
                                    onClickFormActionBtn={onClickFormActionBtn}
                                    isValid={isValid}
                                    control={control}
                                    fieldOptionsForPricing={
                                        fieldOptionsForPricing
                                    }
                                />
                            </CardContent>
                            <CardFooter>
                                <Button
                                    //  disabled={!isValid}
                                    type="submit"
                                    className="ml-auto"
                                >
                                    {isLoading ? (
                                        <BtnLoader />
                                    ) : (
                                        'Create Product'
                                    )}
                                </Button>
                            </CardFooter>
                        </Card>
                    </form>
                </FormProvider>
            </div>
        </>
    );
};
